module.exports = __webpack_public_path__ + "static/media/addToSlack.903aea1b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AddToSlackButton/addToSlack.svg
 ** module id = 614
 ** module chunks = 0
 **/